<template>
  <div>
  <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;" class="query-table" v-if="!isview">
    <tr>
      <td class="header" style="width:60px;">&nbsp;</td>
      <td class="header" style="width:80px;">球镜</td>
      <td class="header" style="width:80px;">柱镜</td>
      <td class="header" style="width:80px;">轴位</td>
      <td class="header" style="width:80px;">瞳距</td>
      <td class="header" style="width:80px;">瞳高</td>
      <td class="header" style="width:200px;">其他</td>
    </tr>
    <tr style="height: 36px">
      <td>
        R
      </td>
      <td>
        <el-input v-model="eyes.R.Y" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode1" class="1" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.R.X" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode2" class="2" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.R.A" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode3" class="3" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.R.J" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode4" class="4" @change="setJ()" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.R.G" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode5" class="5" @change="setG()" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.R.O" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode6" class="6" @keyup.native="move($event)"></el-input>
      </td>
    </tr>
    <tr style="height: 36px">
      <td>
        L
      </td>
      <td>
        <el-input v-model="eyes.L.Y" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode7" class="7" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.L.X" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode8" class="8" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.L.A" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode9" class="9" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.L.J" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode10" class="10" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.L.G" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode11" class="11" @keyup.native="move($event)"></el-input>
      </td>
      <td>
        <el-input v-model="eyes.L.O" style="width: 95%;padding: 0px;" size="mini" ref="Eyescode12" class="12" @keyup.native="move($event)"></el-input>
      </td>
    </tr>
  </table>
  <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;" class="query-table" v-if="isview">
    <tr>
      <td class="header" style="width:40px;text-align: center">&nbsp;</td>
      <td class="header" style="width:50px;text-align: center">球镜</td>
      <td class="header" style="width:50px;text-align: center">柱镜</td>
      <td class="header" style="width:50px;text-align: center" v-if="eyes.R.A||eyes.L.A">轴位</td>
      <td class="header" style="width:50px;text-align: center" v-if="eyes.R.J||eyes.L.J">瞳距</td>
      <td class="header" style="width:50px;text-align: center" v-if="eyes.R.G||eyes.L.G">瞳高</td>
      <td class="header" style="text-align: center" v-if="eyes.R.O||eyes.L.O">其他</td>
    </tr>
    <tr style="height: 28px">
      <td style="text-align: center">
        R
      </td>
      <td style="text-align: center">
        {{eyes.R.Y}}
      </td>
      <td style="text-align: center">
        {{eyes.R.X}}
      </td>
      <td style="text-align: center"  v-if="eyes.R.A||eyes.L.A">
        {{eyes.R.A}}
      </td>
      <td  style="text-align: center"  v-if="eyes.R.J||eyes.L.J">
        {{eyes.R.J}}
      </td>
      <td style="text-align: center"  v-if="eyes.R.G||eyes.L.G">
        {{eyes.R.G}}
      </td>
      <td style="text-align: center"  v-if="eyes.R.O||eyes.L.O">
        {{eyes.R.O}}
      </td>
    </tr>
    <tr style="height: 28px">
      <td style="text-align: center">
        L
      </td>
      <td style="text-align: center">
        {{eyes.L.Y}}
      </td>
      <td style="text-align: center">
        {{eyes.L.X}}
      </td>
      <td style="text-align: center"  v-if="eyes.R.A||eyes.L.A">
        {{eyes.L.A}}
      </td>
      <td style="text-align: center"  v-if="eyes.R.J||eyes.L.J">
        {{eyes.L.J}}
      </td>
      <td style="text-align: center"  v-if="eyes.R.G||eyes.L.G">
        {{eyes.L.G}}
      </td>
      <td style="text-align: center"  v-if="eyes.R.O||eyes.L.O">
        {{eyes.L.O}}
      </td>
    </tr>
  </table>
  </div>
</template>

<script>
    export default {
      name: "RLTable",
      data() {
        return {
          eyes: {R: {Y: "", X: "", A: "", J: "", G: "", O: ""}, L: {Y: "", X: "", A: "", J: "", G: "", O: ""}},
        }
      },
      props: {
        isview:false,
        chufangdan:'',
      },
      methods: {
        reset(){
          for(let key in this.eyes.R){
            this.eyes.R[key]='';
            this.eyes.L[key]='';
          }
        },
        init(rl) {
          this.reset();
          if (!rl) return;
          this.eyes = JSON.parse(rl);
        },
        RLstring(){
          var chufangdan='';
          for(let key in this.eyes.R){
            if(this.eyes.R[key].replace(/ /g, "")||this.eyes.L[key].replace(/ /g, "")){
              chufangdan=JSON.stringify(this.eyes);
              break;
            }
          }
          return chufangdan;
        },
        setJ() {
          this.eyes.L.J = this.eyes.R.J;
        },
        setG() {
          this.eyes.L.G = this.eyes.R.G;
        },
        //方向键方法  //向上 =38 下 = 40 左 = 37 右 = 39
        move(ev) {
          let clssName = parseInt(ev.target.offsetParent.className);
          if (ev.keyCode == 38) {//向上
            if (clssName >= 7)
              this.$refs['Eyescode' + (clssName - 6)].focus();
          } else if (ev.keyCode == 40) {//向下
            if (clssName < 7)
              this.$refs['Eyescode' + (clssName + 6)].focus();
          } else if (ev.keyCode == 37) {//左
            if (clssName > 1)
              this.$refs['Eyescode' + (clssName - 1)].focus();
          } else if (ev.keyCode == 39||ev.keyCode == 13) {//右
            if (clssName < 12)
              this.$refs['Eyescode' + (clssName + 1)].focus();
          }
        },
      },
      mounted(){
        if(this.chufangdan){
          this.init(this.chufangdan)
        }
      }
    }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
    text-align: center;
  }
  .noborder td {
    border: none;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/set/goodsprice/RLTable.vue